import React from "react";
import { Modal } from "react-bootstrap";
import CreateTrialForm from "../crm/customer/CreateTrialForm";

const CreateFreeTrialParent = (props) => {
  return (
    <Modal show={props.show} onHide={props.setModalOpen}>
    <Modal.Header closeButton>
        <Modal.Title>
        Create a Trial Account
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <CreateTrialForm
          mailTriggerPopup={props.mailTriggerPopup}
          formData={props.formData}
          setFormData={props.setFormData}
          apiUrl={props.apiUrl}
          setApiUrl={props.setApiUrl}
          productOptions={props.productOptions}
          closeModal={() => {
            props.setModalOpen(false);
            props.setFormData({
              customerName: "",
              companyName: "",
              phoneNumber: "",
              emailId: "",
              password: "",
              products: [],
            });
          }}
        />
      </Modal.Body>
    </Modal>
  );
};

export default CreateFreeTrialParent;



// WEBPACK FOOTER //
// ./src/components/childcomponents/CreateFreeTrialParent.js